import styled from 'styled-components'
import Link from 'ui/blocks/Link'
import H3 from 'ui/elements/H3'
import Label from 'ui/elements/Label'
import BQuantityInput from 'ui/blocks/QuantityInput'

import { size, color, fontSize, fontWeight } from 'ui/themes/utils'

export const ProductAvailabilityCalendar = styled.div`
  overflow-x: hidden;

  .slide-and-fade-enter {
    opacity: 0;
    transform: translateX(100%);
  }

  .slide-and-fade-exit {
    opacity: 1;
    transform: translateX(0);
  }

  .slide-and-fade-enter-active {
    opacity: 1;
    transform: translateX(0);
  }

  .slide-and-fade-exit-active {
    opacity: 0;
    transform: translateX(-100%);
  }

  .slide-and-fade-enter-active,
  .slide-and-fade-exit-active {
    transition: all 150ms;
  }

  font-family: ${(props) => props.theme.font.body};

  .DayPicker-Caption {
    color: ${color('Text/Primary')};
  }
`

export const CalendarContainer = styled.div``

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: ${size('padding', 'sm')} ${size('padding', 'sm')} 0 !important;

  cursor: pointer;

  ${H3} {
    font-size: calc(${fontSize('md')} + 2px);
    font-weight: ${fontWeight('semibold')};
  }
`

export const InputContainer = styled.div`
  padding: ${size('padding', 'md')} ${size('padding', 'sm')} 0 !important;

  font-weight: ${fontWeight('semibold')} !important;

  display: flex;

  > div:first-child {
    /* Increase flex-basis to allow 3 digit numbers to be fully visible */
    flex-basis: 28%;
  }

  > div:last-child {
    flex-grow: 3;

    margin-left: ${size('margin', 'md')};
  }

  > div:first-child:last-child {
    margin-left: 0;
  }

  .Select__menu {
    margin-top: ${size('margin', 'xs')};
  }

  .Select__option {
    padding: ${size('padding', 'xs')} ${size('padding', 'md')};
    font-weight: ${fontWeight('lighter')};
    font-size: ${fontSize('md')};
  }

  ${Label} {
    font-weight: ${fontWeight('semibold')};
    font-size: ${fontSize('md')};

    margin-bottom: ${size('margin', 'xs')};
  }

  ${BQuantityInput.Control} {
    font-size: calc(${fontSize('sm')} + 1px);
    line-height: ${fontSize('lg')} !important;
  }
`

export const AvailabilityLink = styled(Link)`
  display: inline-block;
  height: 2em;

  text-decoration: underline !important;
`
